/**
 * @flow
 * @relayHash c845ebd0b53ee863706a0ccdf04deda1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateViewerInput = {|
  email?: ?any,
  firstName?: ?string,
  lastName?: ?string,
  currentPassword?: ?string,
  password?: ?string,
|};
export type UpdateViewerMutationVariables = {|
  input: UpdateViewerInput
|};
export type UpdateViewerMutationResponse = {|
  +updateViewer: {|
    +user: {|
      +id: string,
      +email: any,
      +firstName: string,
      +lastName: string,
      +avatar: ?string,
    |}
  |}
|};
export type UpdateViewerMutation = {|
  variables: UpdateViewerMutationVariables,
  response: UpdateViewerMutationResponse,
|};
*/


/*
mutation UpdateViewerMutation(
  $input: UpdateViewerInput!
) {
  updateViewer(input: $input) {
    user {
      id
      email
      firstName
      lastName
      avatar
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateViewerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateViewer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateViewerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "avatar",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateViewerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateViewerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateViewerMutation",
    "id": null,
    "text": "mutation UpdateViewerMutation(\n  $input: UpdateViewerInput!\n) {\n  updateViewer(input: $input) {\n    user {\n      id\n      email\n      firstName\n      lastName\n      avatar\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '12820bb52b427e7172b07ba387ca0470';
module.exports = node;
